(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super()
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul')
      }
      this.elements.button.addEventListener('click', this.openSelector.bind(this))

      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this))

      this.addEventListener('keyup', this.onContainerKeyUp.bind(this))

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)))

      this.onHideDropdown = this.closeSelector.bind(this)
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false')
      this.elements.panel.setAttribute('hidden', true)
      document.body.removeEventListener('click', this.onHideDropdown)
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return

      this.hidePanel()
      this.elements.button.focus()
    }

    onItemClick(event) {
      event.preventDefault()
      const form = this.querySelector('form')
      this.elements.input.value = event.currentTarget.dataset.value
      if (form) form.submit()
    }

    openSelector() {
      this.elements.button.focus()
      this.elements.panel.toggleAttribute('hidden')
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      )

      document.body.addEventListener('click', this.onHideDropdown)
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON'
      if (shouldClose) {
        this.hidePanel()
      }
      let eventTarget = event.target
      if (!eventTarget.closest('.dropdown__open_label')) {
        this.hidePanel()
      }
    }
  }

  customElements.define('localization-form', LocalizationForm)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super()

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value })
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
        }, 300)
      )
    }
  }
  customElements.define('cart-note', CartNote)

  } catch(e) { console.error(e); }
})();
})();
